import { colors } from './const';
import { formatDocBudgetHint } from './doc-read-audit';
import { resolveProjectRoot } from './resolve-project-root';
import { runScaffoldValidation } from './scaffold-validation';

const c = colors;

export interface RunScaffoldCheckOptions {
  projectRoot?: string;
}

export function runScaffoldCheck(options: RunScaffoldCheckOptions = {}): number {
  const projectRoot = resolveProjectRoot(options.projectRoot);
  console.log(`${c.bold}=== CFM SDK — scaffold-check (Phase 1 gate) ===${c.reset}`);
  console.log(`${c.dim}Project: ${projectRoot}${c.reset}\n`);

  const result = runScaffoldValidation(projectRoot);

  for (const warn of result.warnings) {
    console.log(`${c.yellow}WARN:${c.reset} ${warn}`);
  }

  if (result.errors.length > 0) {
    console.log(
      `${c.red}FAIL:${c.reset} Framework scaffold incomplete (${result.framework}) — fix all items before authoring components:`,
    );
    for (const err of result.errors) {
      console.log(`  - ${err}`);
    }
    console.log(`\n${c.dim}Fix: setup/index.md · Next: npx cfm-sdk scaffold-check${c.reset}`);
    return 1;
  }

  if (result.framework !== 'unknown') {
    console.log(`${c.green}OK:${c.reset} Framework scaffold verified (${result.framework})`);
  }

  console.log(
    `${c.dim}Core deps OK. Survey-type deps print after fill-implementation-plan --from-fetch.${c.reset}`,
  );
  console.log(
    `${c.dim}Scaffold complete — run npx cfm-sdk seed-phase5 next.${c.reset}`,
  );
  console.log(`\n${c.dim}${formatDocBudgetHint()}${c.reset}`);
  console.log(`\n${c.dim}Next: Phase 3–4 copy bundle + implementation_plan${c.reset}`);
  return 0;
}
